// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --netsfere-red: rgb(222, 72, 88);
}

/* Global Scrollbar Styles */
::-webkit-scrollbar {
  width: 15px;
  background: transparent;
}

/* Track */
::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  width: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.15);
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.2);
}

::-webkit-scrollbar-thumb:window-inactive {
  background-color: rgba(0, 0, 0, 0.0);
}

.app-container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;AACb","sourcesContent":[":root {\n  --netsfere-red: rgb(222, 72, 88);\n}\n\n/* Global Scrollbar Styles */\n::-webkit-scrollbar {\n  width: 15px;\n  background: transparent;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 10px;\n  width: 15px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n::-webkit-scrollbar-thumb:window-inactive {\n  background-color: rgba(0, 0, 0, 0.0);\n}\n\n.app-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
